import React, {useCallback, useState} from 'react';

import {FormInput} from 'src/components/input';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';


import {useRemoveAlert} from './useRemoveAlertl';

type Props = {
    alertId: number,
    onSuccess: () => void,
    onClose: () => void,
};

export const REMOVE_ALERT_MODAL_WIDTH = 400;

export const RemoveAlertModal = ({alertId, onSuccess, onClose}: Props) => {
    const [reason, setReason] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const {busy, event} = useRemoveAlert({
        alertId,
        onSuccess: () => {
            onSuccess();
            onClose();
        },
        onFail: setErrorMessage,
    });

    const onRemove = useCallback(() => {
        event();
    }, [event]);

    return (
        <>
            <DialogHeader onClose={onClose}>
                Remove Alert
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                {errorMessage ? <Message color="error">{errorMessage}</Message> : null}
                <Group direction="v">
                    Are you sure you want to remove this alert?
                    <FormInput
                        label="Reason"
                        value={reason}
                        onChange={setReason}
                        placeholder="Enter reason"
                        maxLength={128}
                    />
                </Group>
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button busy={busy} variant="Type.PRIMARY" onClick={onRemove} disabled={!reason}>
                        Remove
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
